import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  Button,
  CurrencyInput,
  TextField
} from "components"
import { addPaidIn, addPaidOut } from "@redux"
import { shiftCashManagement } from "services"
import CashManagmentTopbar from "./CashManagmentTopbar"
import CashManagmentSidebar from "./CashManagmentSidebar"
import classes from "./index.module.scss"

const CashManagment = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const [amount, setAmount] = useState(0)
  const [comment, setComment] = useState("")
  const [sending, setSending] = useState(false)
  const [openCashManagmentSidebar, setOpenCashManagmentSidebar] = useState(false)

  const unmount = useRef(false)

  const handlePaidIn = async () => {
    if (amount === 0) return

    const shiftId = shiftCashier[accountId]._id

    const newPaidIn = { amount, comment }

    setSending(true)

    try {
      await shiftCashManagement(shiftId, { paidIn: newPaidIn })

      dispatch(addPaidIn(newPaidIn))

      toast.success(t("عملیات_انجام_شد"))
    } catch (err) {
      toast.error("عملیات_انجام_نشد")
    }

    if (unmount.current) return

    setAmount(0)

    setComment("")

    setSending(false)
  }

  const handlePaidOut = async () => {
    if (amount === 0) return

    const shiftId = shiftCashier[accountId]._id

    const newPaidOut = { amount, comment }

    setSending(true)

    try {
      await shiftCashManagement(shiftId, { paidOut: newPaidOut })

      dispatch(addPaidOut(newPaidOut))

      toast.success(t("عملیات_انجام_شد"))
    } catch (err) {
      toast.error(t("عملیات_انجام_نشد"))
    }

    if (unmount.current) return

    setAmount(0)

    setComment("")

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <CashManagmentSidebar
        openCashManagmentSidebar={openCashManagmentSidebar}
        setOpenCashManagmentSidebar={setOpenCashManagmentSidebar}
      />

      <div
        className={clsx(
          classes["container"],
          isLtr && classes["container-ltr"]
        )}
      >
        <CashManagmentTopbar
          setOpenCashManagmentSidebar={setOpenCashManagmentSidebar}
        />

        <div className={classes["wrapper"]}>
          <div className={classes["inputs"]}>
            <div className={classes["amount"]}>
              <CurrencyInput
                label={t("میزان_پول_تومان")}
                value={amount}
                onChange={value => setAmount(value)}
              />
            </div>

            <div className={classes["amount"]}>
              <TextField
                label={t("یادداشت")}
                value={comment}
                onChange={e => setComment(e.target.value)}
              />
            </div>
          </div>

          <div className={classes["buttons"]}>
            <Button
              color="success"
              loading={sending}
              onClick={handlePaidIn}
              className={clsx(
                classes["button"],
                isLtr && classes["button-ltr"]
              )}
            >
              {t("واریز")}
            </Button>

            <Button
              color="danger"
              loading={sending}
              onClick={handlePaidOut}
            >
              {t("برداشت")}
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default CashManagment